import { render, staticRenderFns } from "./Headline.vue?vue&type=template&id=a13d047c&scoped=true&"
import script from "./Headline.vue?vue&type=script&lang=js&"
export * from "./Headline.vue?vue&type=script&lang=js&"
import style0 from "./Headline.vue?vue&type=style&index=0&id=a13d047c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13d047c",
  null
  
)

component.options.__file = "Headline.vue"
export default component.exports